import { useState, useEffect } from "react"
import Layout from "../components/layout"
import SEOHead from "../components/head"
import { graphql, Slice } from "gatsby"
import {
  ExploreList,
  Hero4,
  Slideshow,
  SlideshowItemType,
  StaffProfileOverview,
  VisualMediaContent,
} from "../components"
import { get } from "lodash"
import { mapStaffData } from "../helpers/data-mappers"
import useStaffData from "../local/hooks/useStaffData"

// @ts-ignore
import staffHero from "../../static/images/hero-default/staff-hero.webp"

export default function Page(props: any) {
  const { getStaffData } = useStaffData()
  const staffProfile = mapStaffData(get(props, "data.staffProfile", {}))
  const { vmedia_content, explore_list, breadcrumbs, staff_department, external_id } = staffProfile

  const [staffSlideshowData, setStaffSlideshowData] = useState<SlideshowItemType[]>([])
  useEffect(() => {
    getStaffData(staff_department[0].external_id || null, external_id).then((data) => {
      return setStaffSlideshowData(data)
    })
  }, [])

  const slider = {
    items: staffSlideshowData,
    title: "Meet Our Experts",
    subtitle: "Our Team All Around The Globe",
  }

  return (
    <>
      {ComposeHead(props)}
      <Layout
        hero={
          <Hero4
            media={[
              {
                variants: [
                  {
                    width: 4096,
                    height: 2729,
                    url: staffHero,
                    alt: "Indonesia Bali",
                    title: "",
                    style: "default",
                  },
                ],
              },
            ]}
            path={breadcrumbs}
          />
        }
      >
        <StaffProfileOverview {...staffProfile} />
        {vmedia_content?.media && vmedia_content?.media.length > 0 && (
          <VisualMediaContent images={vmedia_content?.media} />
        )}
        {explore_list?.items && explore_list.items.length > 0 && <ExploreList {...explore_list} />}
        {slider?.items?.length > 0 && <Slideshow {...slider} />}
        <Slice alias="preFooterStyle5" destinationId={staffProfile?.destinationId} />
      </Layout>
    </>
  )
}

export const ComposeHead = (props: any) => {
  const { staffProfile } = props.data
  const metatag = get(staffProfile, "metatag.items")
  const url = get(staffProfile, "slug")
  const image = get(staffProfile, "photo.variants[0].url")
  return <SEOHead metas={metatag} url={url} image={image} type="profile" />
}

export const query = graphql`
  query ($id: String!) {
    staffProfile(id: { eq: $id }) {
      slug
      title
      id
      external_id
      bio
      slug
      metatag {
        items {
          content
          name
        }
      }
      destinations {
        title
        slug
      }
      staff_department {
        title
        slug
        external_id
        id
      }
      photo {
        ...FieldImage
      }
      fun_facts
      favorite_quote
      optional_category_label
      optional_category_content
      vmedia_content {
        media {
          ...FieldImage
        }
      }
      explore_list {
        ...ExploreList
      }
    }
  }
`
